import ApplicationsPaginationInfo from './ApplicationsPaginationInfo.component';

export default ApplicationsPaginationInfo;